import React, { useMemo } from 'react';

// Styles & Assets
import styles from './PatientAlertsButtons.module.css';
import { ImCross } from 'react-icons/im';

// Hooks
import useDeletePatientAlert from '../../../hooks/useDeletePatientAlert';
import useOverflowList from '../../../hooks/useOverflowList';

// Interfaces
import { IPatientInquiryAlert, IPatientScoreAlert } from '../../../interfaces/Score';
import { Patient } from '../../../interfaces/Patient';
import { InquiryAlertElement, PatientScoreAlert } from '../../Patient/PatientScoreAlert/PatientAlertElement';
interface Props {
    patientID: Patient['id']
    scoreParameterAlerts: IPatientScoreAlert[] | undefined
    inquiryAlerts: IPatientInquiryAlert[] | undefined
}

const PatientAlertsButtons: React.FC<Props> = ({
    patientID, scoreParameterAlerts = [], inquiryAlerts = []
}) => {

    const { handleDelete } = useDeletePatientAlert(patientID)

    const alerts = useMemo(() => {

        const newAlerts = [];

        for (const inquiryAlert of inquiryAlerts) {
            newAlerts.push({
                id: inquiryAlert.id,
                type: 'inquiry' as const,
                element: <InquiryAlertElement inquiryAlert={inquiryAlert} />,
                time: inquiryAlert.time,
            });
        }
        for (const scoreAlert of scoreParameterAlerts) {
            newAlerts.push({
                id: scoreAlert.id,
                type: 'param' as const,
                element: <PatientScoreAlert scoreAlert={scoreAlert} arrowColor='#fff'/>,
                time: scoreAlert.time,
            })
        }
        return newAlerts.sort((a, b) => a.time > b.time ? 1 : -1);

    }, [inquiryAlerts, scoreParameterAlerts])

    const { overflowCount, childrenContainerRef, containerRef } = useOverflowList(alerts);

    return (
        <div className={styles.container} ref={containerRef}>
            <div className={styles.alerts} ref={childrenContainerRef}>
                {alerts.map((alert, index) =>
                    <div
                        key={alert.id}
                        className={styles.alertContainer}
                        style={{ display: index < (alerts.length - overflowCount) ? 'flex' : 'none' }}
                    >
                        {alert.element}
                        <button className={styles.cross} onClick={handleDelete(alert.id, alert.type)}>
                            <ImCross />
                        </button>
                    </div>
                )}
            </div>
            {overflowCount > 0 &&
                <div className={styles.counter}>+{overflowCount}</div>
            }
        </div>
    );
};

export default PatientAlertsButtons;